/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMagnifyingGlass: {
  name: 'magnifying-glass';
  data: string;
} = {
  name: 'magnifying-glass',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 11a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-8a8 8 0 1 0 4.906 14.32l3.387 3.387a1 1 0 0 0 1.414-1.414l-3.387-3.387A8 8 0 0 0 11 3Z" fill="currentColor"/></svg>`,
};
